
import request from "@/utils/request";

// 브랜드 배너 목록
export async function getBrandBannerList(params) {
    console.log("@@ get list : getBrandBannerList");
    let result = request.get("/api/exhibition/banner/brand/",{params});
    return result;
}
// 채널 배너 목록
export async function getChannelBannerList(params) {
    console.log("@@ get list : getChannelBannerList");
    let result = request.get("/api/exhibition/banner/channel/",{params});
    return result;
}

// 브랜드 배너 상세
export async function getBrandBannerDetail(params) {
    console.log("@@ get list : getBrandBannerDetail");
    let result = request.get("/api/exhibition/banner/detail/brand",{params});
    return result;
}
// 채널 배너 상세
export async function getChannelBannerDetail(params) {
    console.log("@@ get list : getChannelBannerDetail");
    let result = request.get("/api/exhibition/banner/detail/channel",{params});
    return result;
}

// 브랜드 배너 저장
export async function saveBrandBanner(params) {
    console.log("@@ post save : saveBrandBanner");
    let result = request.post(`/api/exhibition/banner/save/brand`,params);
    return result;
}

// 채널 배너 저장
export async function saveChannelBanner(params) {
    console.log("@@ post save : saveChannelBanner");
    let result = request.post(`/api/exhibition/banner/save/channel`,params);
    return result;
}

// 브랜드/채널 배너 배치변경(노출, 순서)
export async function saveBannerList(params) {
    console.log("@@ post save : saveBrandBannerList");
    let result = request.post(`/api/exhibition/banner/listUpdate`,params);
    return result;
}

// 브랜드/채널 배너 삭제
export async function deleteBanner(params) {
    console.log("@@ post delete : deleteBrandBanner");
    let result = request.post(`/api/exhibition/banner/delete`,params);
    return result;
}
